/**
 * 全局状态
 */
const mixins = {
    namespaced: true,
    state: {
        createSideNav: false,
        triggerSideNavShow: true,
        reloadSideNav: true,
        isAllSelect: false,
        isShowPage: false,
        isLangType: true,
        isTagsActive: -1,
        isFilterBtn: false,
        currentDoc: null
    },
    mutations: {
        updateOpenSideNav(state, status) {
            if (status.reset) {
                setTimeout(() => {
                    state.reloadSideNav = status.show;
                }, 140);
            } else {
                state.reloadSideNav = true;
            }

            state.triggerSideNavShow = status.show;
        },

        updateAllSelect(state, isChecked) {
            state.isAllSelect = isChecked;
        },
        updateIsFilterBtn(state, isShow) {
            state.isFilterBtn = isShow;
        },
        updateCurrentDoc(state, doc) {
            state.currentDoc = doc;
        }
    }
};
export default mixins;
